module.exports = __webpack_public_path__ + "static/media/icon-options-table.a86abf7c.svg";